<template>
  <div class="deposit-container">
    <p class="title">واریز {{ $coins[$route.params.coin].persianNames }}</p>
    <div class="info-container">
      <div class="coin-info">
        <div>
          <p class="label">نوع کوین</p>
          <div class="selected-container" @click="drop = !drop">
            <img class="list-img" :src="$coins[$route.params.coin].link" />
            <span> {{ $coins[$route.params.coin].persianName }} </span>
            <img class="dropIcon" src="@/assets/dropIcon.svg" alt="" />
            <div class="drop-down" v-if="drop">
              <div
                @click="selectWallet(wallet)"
                v-for="(wallet, index) in wallets"
                :key="index"
              >
                <img class="list-img" :src="$coins[wallet.relatedCoin].link" />
                <span> {{ $coins[wallet.relatedCoin].persianName }} </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="label">آدرس کیف پول</p>
          <div @click="copy" class="selected-conteiner">
            <img
              v-if="showQr"
              class="qrcode"
              :src="'data:image/png;base64,' + qrCode"
            />
            <input
              class="address-input"
              type="text"
              v-model="address"
              disabled
            />
            <inline-svg
              @mouseover="showQr = true"
              @mouseleave="showQr = false"
              :src="require('@/assets/icons/qrCode.svg')"
            />
          </div>
        </div>
        <!-- <div>
          <p class="label">شناسه واریز</p>
          <div class="deposite-check">
            <input class="address-input" type="text" v-model="depositeCode" />
          </div>
        </div> -->

        <div>
          <p class="label">شبکه</p>
          <div class="selected-container" @click="netDrops = !netDrops">
            <!--            <img class="list-img" :src="$coins[$route.params.coin].link">-->
            <!--            <span> {{-->
            <!--                $coins[$route.params.coin].persianName-->
            <!--              }} </span>-->
            {{ selectedNet }}
            <img class="dropIcon" src="@/assets/dropIcon.svg" alt="" />
            <div class="drop-down" v-if="netDrops">
              <div
                @click="selectNet(net)"
                v-for="(net, index) in nets"
                :key="index"
              >
                <!--                <img class="list-img" :src=" $coins[wallet.relatedCoin].link">-->
                <span> {{ net.tokenType }} </span>
              </div>
            </div>
          </div>
        </div>

        <!-- :disabled="!depositeCode" -->
        <button @click.prevent="checkDeposite" class="normal-btn">
          بررسی واریز
        </button>
      </div>
      <div class="guide-container">
        <div>راهنمای واریز</div>
        <div class="warning-container">
          <img src="@/assets/warning.svg" alt="" />
          <span>
            ارسال کوین غیر از {{ $coins[$route.params.coin].code }} به این آدرس
            ممکن است منجر به از دست دادن آن برای همیشه شود.
          </span>
        </div>
      </div>
    </div>
    <div class="history-container">
      <p>تاریخچه واریز {{ $coins[$route.params.coin].persianName }}</p>
      <div class="table-contaner">
        <span v-if="tableContents.length < 1" class="no-content">
          محتوایی جهت نمایش وجود ندارد
        </span>

        <table>
          <tr class="tr-head">
            <td class="date">زمان</td>
            <td>رمزارز</td>
            <td>مقدار درخواستی</td>
            <td class="address">کارمزد شبکه</td>
            <td class="destination">آدرس مقصد</td>
            <td>وضعیت</td>
            <td class="trnasactionId">شناسه تراکنش</td>
          </tr>
          <tr
            class="tr-body"
            v-for="(item, index) in tableContents"
            :key="index"
          >
            <td class="date">۰۰/۲/۲ ۱۲:۲۳</td>
            <td>بیت کوین</td>
            <td>0.004</td>
            <td class="address">5%</td>
            <td class="destination">gwerfuygerf876876</td>
            <td class="success">موفق</td>
            <td class="trnasactionId">مشاهده جزییات</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoinDeposit",
  component: {},
  data() {
    return {
      netDrops: false,
      // depositeCode: "",
      address: "",
      qrCode: "",
      drop: false,
      wallets: [],
      nets: [],
      selectedNet: "",
      selectCoin: [],
      showQr: false,
      tableContents: [],
      page: 1,
      lastPage: 1,
    };
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.address);
      this.$error("", "آدرس کپی شد", "info", "تایید");
    },
    async getDeposite() {
      this.state.loading = true;
      const res = await this.$axios.get("/wallets/deposit", {
        params: {
          size: 10,
          page: this.page,
          type: "dep",
        },
      });
      if (res) {
        this.lastPage = res.totalPages;
        let content = res.content.filter(
          (a) => a.relatedCoin == this.$route.params.coin
        );
        this.tableContents = content; //for scroll loading
        // this.tableContents = res.content //for pagination
      }
    },
    async getWallets() {
      this.state.loading = true;
      const res = await this.$axios.get("/wallets/customer-addresses");
      let entireRes = Object.entries(res);
      this.sortWallets(entireRes);
    },
    sortWallets(e) {
      const sortCoins = [
        "TOMAN",
        "TETHER",
        "BITCOIN",
        "ETHEREUM",
        "BITCOIN_CASH",
        "LITE_COIN",
        "RIPPLE",
        "CLASSIC_ETHEREUM",
        "DASH",
        "DOGE_COIN",
      ];
      e.sort((a, b) => sortCoins.indexOf(a[0]) - sortCoins.indexOf(b[0]));
      this.wallets = e.map((a) => {
        let relatedCoin = a[0];
        if (a.relatedCoin) {
          a = a[1];
        } else {
          a = a[1];
          a.relatedCoin = relatedCoin;
        }
        return a;
      });
      this.wallets = this.wallets.filter(
        (wallet) => wallet.relatedCoin !== "TOMAN"
      );
      this.wallets.sort((a, b) => b.credit - a.credit);
    },
    async checkDeposite() {
      this.state.loading = true;
      const res = await this.$axios.get(
        "/wallets/check-confirmed-transaction",
        {
          params: {
            relatedCoin: this.$route.params.coin,
            cryptoNetwork: this.selectedNet,
          },
        }
      );
      res
        ? this.$error(
            "پیگیری واریز",
            "مقدار واریز شناسایی نشد",
            "info",
            "تایید"
          )
        : "";
    },

    async setCoin() {
      this.state.loading = true;
      const res = await this.$axios("/coins/details");
      this.selectCoin = res.content.find(
        (c) => c.name === this.$route.params.coin
      );
      console.log(this.selectCoin);
      this.nets = this.selectCoin.tokenTypeDetails;
      console.log(this.nets);
      this.selectedNet = this.selectCoin.tokenTypeDetails[0].tokenType;

      this.getSelectedWallet();
    },
    async getSelectedWallet() {
      this.state.loading = true;
      const [res, err] = await this.$http.get(
        `/wallets/customer/wallet-address`,
        {
          params: {
            relatedCoin: this.selectCoin.name,
            tokenType: this.selectedNet,
          },
        }
      );
      if (res) {
        this.address = res.baseDTO.address;
        this.qrCode = res.baseDTO.qrCode;
      }
      if (err) {
        this.$router.push({ name: "Wallet" });
      }
    },
    async selectWallet(wallet) {
      this.$router.push("/dashboard/deposit-coin/" + wallet.relatedCoin);
      await this.getDeposite();
      await this.getWallets();
      this.setCoin();
    },
    selectNet(net) {
      this.selectedNet = net.tokenType;
      this.getSelectedWallet();
      // this.$axios.get("/wallets/customer/wallet-address", {
      //   params: {
      //     tokenType: this.selectedNet,
      //     relatedCoin: this.$route.params.coin,
      //   },
      // });
    },
  },
  async mounted() {
    await this.getDeposite();
    await this.getWallets();
    this.setCoin();
  },

  created: function () {
    window.addEventListener("click", (event) => {
      if (!event.target.closest(".selected-container")) {
        this.drop = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../Styles/Wallet.scss";

.qrcode {
  position: absolute;
  width: 124px;
  height: 124px;
  top: 20px;
  left: -10px;
}

.coin-info {
  position: relative;
}

.limit-container {
  cursor: text !important;
}

.drop-down {
  z-index: 3;
  max-height: 250px;
  overflow-y: scroll;
}

.selected-conteiner {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  width: 100%;
  background: var(--light-grey);
  border-radius: 8px;
  align-items: center;

  input {
    cursor: pointer;
    flex: 9;
  }

  svg {
    cursor: pointer;
    transition: 300ms;
    flex: 1;
    width: 20px;
    height: 20px;

    &:hover {
      fill: var(--primary-color) !important;
    }
  }
}
</style>
